export const BACKEND_API_PATHS = {
  initialSettings: "/api/initial-settings",
  launchContext: "/api/launch-context",
  currencyCatalog: "/api/currency-catalog",
  playSession: "/api/session",
  roundRequest: "/api/spin",
  presentationComplete: "/api/presentation-complete",
  replay: "/api/replay",
  gambleRequest: "/api/gamble",
  gambleComplete: "/api/gamble/complete",
  history: "/api/history",
} as const;
